import { useNavigate } from "react-router-dom";
import FileUpload from "../../components/elements/FileUpload";
import { useContext, useEffect, useState } from "react";
import { QuickShareContext } from "../QuickSharePage";
// import BIcon from "../../components/BIcon";
import check from "../../assets/check.png";
// import cross from "../../assets/x.png";
import TabSwitch from "../../components/TabSwitch";
export default function QuickShareNew() {
  const { hasBeenSentLink, k, remoteSessionId, transferDirection } =
    useContext(QuickShareContext);
  const navigate = useNavigate();


  // const handleToggle = () => {
  //   const newMode = !isCloudMode;
  //   setIsCloudMode(newMode);

  //   if (newMode) {
  //     window.location.href = "https://0.rw/2";
  //   } else {
  //    window.location.href = "https://0.rw/1"; // Update to your actual P2P Mode path
  //   }
  // };

  const handleFiles = (files) => {
    if (hasBeenSentLink) {
      navigate("progress", {
        state: {
          files,
          // These fields are prepopulated from link
          k,
          remoteSessionId,
          transferDirection,
        },
      });
    } else {
      navigate("progress", {
        state: {
          files,
          transferDirection: "S",
        },
      });
    }
  };

  const onReceiveClicked = (e) => {
    navigate("progress", {
      state: {
        transferDirection: "R",
      },
    });
  };

  const [stars, setStars] = useState(null);

  useEffect(() => {
    fetch("https://api.github.com/repos/robinkarlberg/transfer.zip-web", {
      credentials: "omit",
      method: "GET",
    })
      .then((res) => res.json())
      .then((json) => {
        setStars(json.stargazers_count);
      })
      .catch((err) => {
        console.log("GitHub stars fetch error :(");
      });
  }, []);

  return (
    <div className="w-full   max-w-[90vw] md:max-w-[70vw] text-center flex flex-col items-center">
       <div className="container hidden mx-auto px-2 lg:px-8 mb-6 sm:flex justify-center">
     <TabSwitch />
     </div>
      {/* <div className="flex items-center justify-center mb-8 gap-3 text-lg font-medium">
        <span
          className={`text-[24px] font-[700] ${
            isCloudMode ? "text-white" : "text-[#12A500]"
          }`}
        >
          P2P Mode
        </span>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            className="sr-only peer"
            checked={isCloudMode}
            onChange={handleToggle}
          />
          <div
            className="w-11 h-6 bg-[#34C759] peer-focus:outline-none rounded-full peer dark:bg-[#34C759] 
                  peer-checked:after:translate-x-full peer-checked:after:border-white 
                  after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
                  after:bg-white after:border-gray-300 after:border after:rounded-full 
                  after:h-5 after:w-5 after:transition-all"
          ></div>
        </label>
        <span className={`text-[24px] text-[#A168FA]`}>Cloud Mode</span>
      </div> */}
      <div className={hasBeenSentLink ? "mb-2" : "mb-8"}>
        <h1 className="mb-2 leading-tight text-3xl text-white sm:text-4xl font-medium tracking-tight text-center">
          Peer-to-Peer File Transfer
        </h1>
        <h2 className="leading-normal sm:mx-auto mt-2 text-base sm:text-lg text-white text-center">
          {hasBeenSentLink
            ? "Someone has requested you to send files!"
            : "Send any size files securely, encrypted and directly between two devices."}
        </h2>
      </div>
      <FileUpload
        onFiles={handleFiles}
        onReceiveClicked={hasBeenSentLink ? undefined : onReceiveClicked}
      />
      <div class="text-white text-start my-10 flex flex-col gap-4 w-[70%] sm:w-[250px] items-start sm:gap-5 sm:text-base text-sm">
        <div class="flex flex-row gap-3 items-start sm:items-center">
          <img src={check} class="w-7 h-7" />
          <span className="text-base">No central server or cloud</span>
        </div>
        <div class="flex flex-row gap-3 items-start sm:items-center">
          <img src={check} class="w-7 h-7" />
          <span className="text-base">No limit on File Size</span>
        </div>
        <div class="flex flex-row gap-3 items-start sm:items-center">
          <img src={check} class=" w-7 h-7" />
          <span className="text-base">
            Transfers expire when browser tab is closed
          </span>
        </div>
      </div>
    </div>
  );
}
